/* eslint-disable */

export const setPaddings = () => {
  const container = $('.container:visible').width();
  const win = $(window).width();
  const padding = (win - container) / 2;

  $('#hero-dots').css('left', padding);
  $('#callbackButton').css('right', padding);
  $('.inline-gallery-wrapper .owl-prev').css('left', padding);
  $('.inline-gallery-wrapper .owl-next').css('right', padding);
};

export const setPagination = () => {
  if ($('.post-navigation').length > 0) {
    const prev = $('.post-navigation ul.page-numbers li a.prev');
    const next = $('.post-navigation ul.page-numbers li a.next');
    const numbers = $('.post-navigation ul.page-numbers');

    prev.parent('li').addClass('prev-page');
    next.parent('li').addClass('next-page');
    prev.addClass('nav-button');
    next.addClass('nav-button');

    if ($('.post-navigation ul.page-numbers li.prev-page').length === 0) {
      numbers.prepend('<li class="prev-page off">PREV</li>');
    }

    if ($('.post-navigation ul.page-numbers li.next-page').length === 0) {
      numbers.append('<li class="next-page off">NEXT</li>');
    }

    numbers.find('.current').parent('li').addClass('current-page');

    numbers.children('li').each(function(i) {
      if (!$(this).hasClass('prev-page') && !$(this).hasClass('next-page')) {
        const el = $(this).find('.page-numbers');
        if (i <= 10) {
          const oldVal = el.html();
          el.html('0' + oldVal);
        }
      }
    });
  }
};




// WEBPACK FOOTER //
// ./scripts/routes/utils.js